<template>
    <div class="container" v-loading="loading">
        <apply-header :flag="'1'"></apply-header>
        <div class="main" :style="{'min-height':(getHeight-80)+'px'}">
            <Side :step="'2'"></Side>
            <section>
                <div class="info-form" v-if="!showResult&&hasFinished">
                    <div class="box">
                        <h1 class="serviceTestTitle">Dental Accounting Application Test</h1>
                    </div>
                    <el-form :model="form" ref="form" :rules="rules">
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub0!=1" :src="wrong"></el-image>
                                1) Your client's credit cards deposit in the bank two business days after they are ran. Thursday, the software deposit slip shows $1059.80 posted. Friday, the software deposit slip shows $5,867.21 posted. The bank deposits on Monday are $1,689.54 and $5,037.18. How much of a discrepancy is there?<span class="required">*</span></div>
                                <div class="score" >1 points</div>
                                <!-- 答案第三个 -->
                            <el-form-item prop="sub0" ref="sub0">
                                <el-radio-group v-model="form.sub0" :disabled="isAdmin">
                                    <el-radio :label="0">629.74 short in the software</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="1">200.29 short in the bank</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub0!=1" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="2">200.29 short in the software</el-radio><br>
                                    <el-radio :label="3">629.74 short in the bank</el-radio><br>  
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub1!=0" :src="wrong"></el-image>
                                2) When will a company record revenue using Cash Basis Accounting?<span class="required">*</span></div>
                                <div class="score" >1 points</div>
                            <el-form-item prop="sub1" ref="sub1">
                                <el-radio-group v-model="form.sub1" :disabled="isAdmin">
                                    <div class="review">
                                        <el-radio :label="0">When it is collected.</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub1!=0" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="1">At the same time as accounts receivable.</el-radio><br>
                                    <el-radio :label="2">When the funds are used.</el-radio><br>
                                    <el-radio :label="3">When it is earned.</el-radio><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub2!=1" :src="wrong"></el-image>
                                3) What is the first step you would take if there was a returned deposit in the Clients Bank account? <span class="required">*</span></div>
                                <div class="score" >1 points</div>
                            <el-form-item prop="sub2" ref="sub2">
                                <el-radio-group v-model="form.sub2" :disabled="isAdmin">
                                    <el-radio :label="0">Email the Client to inform them there was a returned deposit.</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="1">Look at the Bank Memo for any information about what deposit was returned.</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub2!=1" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="2">Review previous deposits to see which one it matches.</el-radio><br>
                                    <el-radio :label="3">Ignore it, as you are just looking for new income into the account.</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub3!=3" :src="wrong"></el-image>
                                4) A bank connection error has occurred and you need to disconnect/reconnect a feed.  Which occurrence below will happen when you disconnect/reconnect the feed:  <span class="required">*</span></div>
                                <div class="score" >1 points</div>
                            <el-form-item prop="sub3" ref="sub3" >
                                <el-radio-group v-model="form.sub3" :disabled="isAdmin">
                                    <el-radio :label="0">You will have to setup a new account in the chart of accounts to map the feed to</el-radio><br>
                                    <el-radio :label="1">Transactions will begin downloading as of the date that you reset the connection</el-radio><br>
                                    <el-radio :label="2">Unposted transactions remaining in the downloaded transaction window will disappear</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="3">90 days of transactions will download and will match to existing downloaded transactions if they are duplicates</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub3!=3" class="rightPic" :src="right"></el-image>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub4!=1" :src="wrong"></el-image>
                                5) What steps would you take if your Deposit Total was off by $0.03 compared to what was deposited in the bank?<span class="required">*</span></div>
                                <div class="score" >1 points</div>
                            <el-form-item prop="sub4" ref="sub4">
                                <el-radio-group v-model="form.sub4" :disabled="isAdmin">
                                    <el-radio :label="0">Not worry about it, since it is pennies off and mark it as balanced.</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="1">Compare payment totals per Trace/Check # to what was deposited. Communicate with the poster of which payment is posted in error and request to be fixed and proof of correction.</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub4!=1" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="2">Communicate with the poster a payment is posted in error and request to be fixed and proof of correction.</el-radio><br>
                                    <el-radio :label="3">Communicate with the poster that there is a $0.03 error in the total.</el-radio><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub5!=2" :src="wrong"></el-image>
                                6) Your client has categorized all payments to a particular vendor as Office Rent; they should have been categorized as Utilities. Which Accountant tool is useful to remedy this issue? <span class="required">*</span></div>
                                <div class="score" >1 points</div>
                            <el-form-item prop="sub5" ref="sub5">
                                <el-radio-group v-model="form.sub5" :disabled="isAdmin">
                                    <el-radio :label="0">Adjusting Journal Entries</el-radio><br>
                                    <el-radio :label="1">Undo Bank Reconcliation</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="2">Reclassify Transactions</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub5!=2" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="3">Write off invoices in a batch</el-radio><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub6!=4" :src="wrong"></el-image>
                                7) What is the reasoning behind why a Credit Card Bank Deposit does not match a Credit Card payment posted to an account?<span class="required">*</span></div>
                                <div class="score" >1 points</div>
                            <el-form-item prop="sub6" ref="sub6">
                                <el-radio-group v-model="form.sub6" :disabled="isAdmin">
                                    <el-radio :label="0">Refund ran same day and taken out of total Deposit</el-radio><br>
                                    <el-radio :label="1">A payment was ran, but was not posted to an account.</el-radio><br>
                                    <el-radio :label="2">A payment was posted to an account, but not ran.</el-radio><br>
                                    <el-radio :label="3">Merchant Fees are removed from total daily deposits.</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="4">All of the above.</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub6!=4" class="rightPic" :src="right"></el-image>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub7!=2" :src="wrong"></el-image>
                                8) Some transactions were downloaded from the bank and matched to the wrong transactions existing in the account register. The best way to work with these transactions: <span class="required">*</span></div>
                                <div class="score" >1 points</div>
                            <el-form-item prop="sub7" ref="sub7">
                                <el-radio-group v-model="form.sub7" :disabled="isAdmin">
                                    <el-radio :label="0">Delete the transaction from the register and re-post</el-radio><br>
                                    <el-radio :label="1">"Exclude" the transactions from the downloaded transactions window</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="2">"Undo" the transactions from the "In QuickBooks" tab in the transactions window</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub7!=2" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="3">Re-download the transactions from the bank and re-post them to the proper account.</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub8!=1" :src="wrong"></el-image>
                                9) The Balance Sheet reflects all current dollar amounts in each Account and is not affected by anything on the Profit & Loss Statement.<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub8" ref="sub8">
                                <el-radio-group v-model="form.sub8" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="1">False</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub8!=1" class="rightPic" :src="right"></el-image>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub9!=2" :src="wrong"></el-image>
                                10) Which of the following is a liability account? <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub9" ref="sub9">
                                <el-radio-group v-model="form.sub9" :disabled="isAdmin">
                                    <el-radio :label="0">Retained Earnings</el-radio><br>
                                    <el-radio :label="1">Prepaid Rent</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="2">Unearned Revenue</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub9!=2" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="3">Accumulated Depreciation</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub10!=3" :src="wrong"></el-image>
                                11) You noticed the Credit Card has several Airline and Hotel charges for a three day period. How would you categorize these expenses in QuickBooks Online?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub10" ref="sub10">
                                <el-radio-group v-model="form.sub10" :disabled="isAdmin">
                                    <el-radio :label="0">Travel</el-radio><br>
                                    <el-radio :label="1">Travel Airfare and Travel Lodging</el-radio><br>
                                    <el-radio :label="2">Personal Expenses</el-radio><br> 
                                    <div class="review">
                                        <el-radio :label="3">Confirm with the client what these charges were used for, and then categorize appropriately.</el-radio>
                                        <el-image v-if="isAdmin&&form.sub10!=3" class="rightPic" :src="right"></el-image>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub11!=2" :src="wrong"></el-image>
                                12) Which of the following is a step to merge two accounts together in the chart of accounts?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub11" ref="sub11">
                                <el-radio-group v-model="form.sub11" :disabled="isAdmin">
                                    <el-radio :label="0">Deactivate the old account</el-radio><br>
                                    <el-radio :label="1">Change the company preferences</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="2">Edit one account and name it exactly as the other</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub11!=2" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="3">Add new account and reclassify all transactions to the new account</el-radio><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub12!=1" :src="wrong"></el-image>
                                13) A client has multiple locations for their business, however all credit card deposits are run under the same terminal resulting in one deposit to the bank. The client would like to see what each office collects in Quickbooks. What is the best way to categorize these deposits to reflect that?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub12" ref="sub12">
                                <el-radio-group v-model="form.sub12" :disabled="isAdmin">
                                    <el-radio :label="0">Utilize Locations Settings</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="1">Utilize Classes Settings</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub12!=1" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="2">Delete deposit and enter as individual amounts per office</el-radio><br>
                                    <el-radio :label="3">Create Payee's per office and enter individual amounts</el-radio><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub13!=3" :src="wrong"></el-image>
                                14) What is the best way to determine the payment posted to a patients account is the same payment that was deposited in the bank?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub13" ref="sub13">
                                <el-radio-group v-model="form.sub13" :disabled="isAdmin">
                                    <el-radio :label="0">Total Amount</el-radio><br>
                                    <el-radio :label="1">Trace Number</el-radio><br>
                                    <el-radio :label="2">Insurance Name</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="3">All of the Above</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub13!=3" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="4">None of the Above.</el-radio><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub14!=3" :src="wrong"></el-image>
                                15) If employee Alice is paid $10 an hour and recorded the following hours for the workweek, what are her gross wages for the workweek under federal law? Hours on the job 36 Commuting between home and the job site 10 Lunch hours 5 Total hours 51<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub14" ref="sub14">
                                <el-radio-group v-model="form.sub14" :disabled="isAdmin">
                                    <el-radio :label="0">$410</el-radio><br>
                                    <el-radio :label="1">$412</el-radio><br>
                                    <el-radio :label="2">$510</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="3">$360</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub14!=3" class="rightPic" :src="right"></el-image>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub15!=3" :src="wrong"></el-image>
                                16) Your client's credit cards deposit in the bank two business days after they are ran. Thursday, the software deposit slip shows $1059.80 posted. Friday, the software deposit slip shows $5,867.21 posted. The bank deposits on Monday are $1,689.54 and $5,037.18. What would you initially ask the client to help clarify these differences?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub15" ref="sub15">
                                <el-radio-group v-model="form.sub15" :disabled="isAdmin">
                                    <el-radio :label="0">Were there any refunds ran on Thursday, Friday or over the weekend?</el-radio><br>
                                    <el-radio :label="1">Are all payments posted in the software, posted correctly in comparison to what is ran in the merchant terminal?</el-radio><br>
                                    <el-radio :label="2">Were the payments ran on Thursday all posted on Thursday, or were there any payments posted ran Thursday but posted Friday?</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="3">All of the above.</el-radio>
                                        <el-image v-if="isAdmin&&form.sub15!=3" class="rightPic" :src="right"></el-image>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub16!=2" :src="wrong"></el-image>
                                17) When going in to reconcile a bank account and the beginning balance does not match the statement. Where can you view account's reconciled period?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub16" ref="sub16">
                                <el-radio-group v-model="form.sub16" :disabled="isAdmin">
                                    <el-radio :label="0">Chart of accounts</el-radio><br>
                                    <el-radio :label="1">Reconciliation Report</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="2">Reconciliation History</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub16!=2" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="3">Banking Changes screen</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub17!=4" :src="wrong"></el-image>
                                18) Which of the following are embezzlement warning signs?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub17" ref="sub17">
                                <el-radio-group v-model="form.sub17" :disabled="isAdmin">
                                    <el-radio :label="0">Credit Adjustments made do not make sense</el-radio><br>
                                    <el-radio :label="1">High Accounts Receivable</el-radio><br>
                                    <el-radio :label="2">Detached Doctor of the Practice</el-radio><br> 
                                    <el-radio :label="3">None of the Above</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="4">All of the Above</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub17!=4" class="rightPic" :src="right"></el-image>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub18!=3" :src="wrong"></el-image>
                                19) You have a client who uses a local credit union that does not synch with Quickbooks Online. The best way to get the transactions into Quickbooks online is: <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub18" ref="sub18">
                                <el-radio-group v-model="form.sub18" :disabled="isAdmin">
                                    <el-radio :label="0">Hand key transactions into the account register.</el-radio><br>
                                    <el-radio :label="1">Download and import a Direct Connect File with the Import Data Tool</el-radio><br>
                                    <el-radio :label="2">Download and import an ILF File with the Import Data Tool</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="3">Download and import a .qbo file through the Transaction Window</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub18!=3" class="rightPic" :src="right"></el-image>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub19!=2" :src="wrong"></el-image>
                                20)What are the benefits of bank reconciliation?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub19" ref="sub19">
                                <el-radio-group v-model="form.sub19" :disabled="isAdmin">
                                    <el-radio :label="0">Reduce Fraud, Correct Bank Errors</el-radio><br>
                                    <el-radio :label="1">Ensure what is posted to an account is deposited in the bank, Reduce Fraud, Correct Bank Errors, Correct Posting Errors</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="2">Correct Posting Errors, Reduce Fraud, Ensure what is posted to an account is deposited in the bank</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub19!=2" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="3">Correct Bank Errors, Correct Posting Errors</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="btnLayout" style="margin:0 0 10px 5px">
                            <el-button class="yellowBtn" @click="submitPrepare" v-if="!isAdmin">Submit</el-button>
                            <el-button class="grayBtn" @click="cancel"  v-if="!isAdmin">Cancel</el-button>
                            <span style="margin-left:10px" v-if="isAdmin">Exam Completed {{ forMateTime(finishDate,true) }}</span>
                        </div>
                    </el-form>
                </div>
                <div class="box" v-if="showResult&&hasFinished">
                    <h1 class="serviceTestTitle">Dental Accounting Assessment Test</h1>
                    <!--
                    <span>Of the parts of this exam that can be automatically graded you have recieved </span>
                    <span>{{correctNum}}</span>/{{totalNum}} ({{correctPercent}})-->
                    <span>Thank you for completing this knowledge assessment!</span><br/>
                    <span>Please allow up to three business days while we review your application.</span>
                    <br>
                    <el-button class="yellowBtn" style="margin-top: 10px;" @click="goPre">Back</el-button>
                </div>
            </section>
        </div>
        <el-dialog title="Confirm" :visible.sync="exitVisible">
            <div>Are you sure you want to cancel the test?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="goBack">Yes</el-button>
                <el-button class="grayBtn" @click="exitVisible=false">No</el-button>
            </span>
        </el-dialog>
        <el-dialog title="Confirm" :visible.sync="confirmVisible" width="50%">
            <div style="line-height: 25px;padding: 0 10px;word-wrap:break-word">Caution:this portion of our skills assessment test you are about to view cannot be saved for later. You will
                be scored with no option to return later if you proceed. Do you want to continue?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="submit">Yes</el-button>
                <el-button class="grayBtn" @click="confirmVisible=false">No</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="Assessment Complete"
            :visible.sync="completionDialogVisible"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="50%">
            <div style="text-align: center">
                <p>Thank you for completing this knowledge assessment.</p>
                <p>Please allow up to three business days while we review your application.</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="yellowBtn" @click="handleCompletionConfirm">OK</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import ApplyHeader from "../../components/ApplyHeader"
    import Side from '../../components/Aside.vue'
    import wrong from "../../assets/pic/wrong.png"
    import right from "../../assets/pic/right.png"
    import { chat2Ascii } from "../../../static/js/util"
    export default {
        name:'dentalAccountingV2Test',
        components:{ApplyHeader,Side},
        data(){
            return {
                finishDate:'',
                totalNum:20,
                correctNum:0,
                confirmVisible:false,
                exitVisible:false,
                loading:false,
                showResult:false,
                hasFinished:false,
                wrong:wrong,
                right:right,
                isAdmin:false,
                completionDialogVisible: false, 
                form:{
                    sub0:'',
                    sub1:'',
                    sub2:'',
                    sub3:'',
                    sub4:'',
                    sub5:'',
                    sub6:'',
                    sub7:'',
                    sub8:'',
                    sub9:'',
                    sub10:'',
                    sub11:'',
                    sub12:'',
                    sub13:'',
                    sub14:'',
                    sub15:'',
                    sub16:'',
                    sub17:'',
                    sub18:'',
                    sub19:'',
                },
                rules:{
                    sub0:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub1:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub2:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub3:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub4:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub5:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub6:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub7:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub8:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub9:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub10:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub11:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub12:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub13:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub14:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub15:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub16:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub17:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub18:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub19:[{ required: true, message: 'Required', trigger: 'blur' },],
                }
            }
        },
        mounted(){
            this.getData()
        },
        computed:{
            getHeight(){
                return document.documentElement.clientHeight
            },
            /**根据用户自己选择算出正确率**/
            correctPercent(){
                let per = Number(100*this.correctNum/this.totalNum).toFixed(2)
                return per+'%'
            },
        },
        methods:{
            goPre(){
                this.$router.go(-1)
            },
            getUserAnswerData(id,email){
                // console.log('id',id);
                // console.log('email',email);
                this.loading=true
                this.$axios.get(this.$URL.gradeUrl,{params:{serviceId:id,email:email}}).then(res=>{
                    this.loading=false
                    if(res&&res.code==0){
                        this.hasFinished=true
                        // console.log('用户答题数据',res)
                        /**取到用户答题数据重构form显示答题详情**/
                        if(res.data&&res.data.detail!=null){
                            this.finishDate = res.data.finishDate||''
                            var list = res.data.detail
                            for(var i=0;i<list.length;i++){
                                this.$set(this.form,('sub'+i),list[i])
                            }
                            this.calScore()
                        }
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error({message:err})
                })
            },
            getData(){
                // console.error(chat2Ascii('94441828@qq.com'))
                if(this.$route.query&&this.$route.query.model=='review'&&this.$route.query.verify){
                    var serviceId = this.$route.query.serviceId
                    var email = this.$route.query.email
                     var verify = this.$route.query.verify
                    var verifyCode = chat2Ascii(email)
                    if(verifyCode!=verify){
                         this.$router.push('/login')
                        return
                    }
                    this.getUserAnswerData(serviceId,email)
                    this.isAdmin=true
                    return
                }
                var storeService = this.$store.state.serviceInfo
                //when no serviceid info, go back to service list
                // console.log('get serviceId:' + storeService.serviceId)
                if(storeService.serviceId == undefined){
                    this.$router.push({path:'/service'})
                    return
                }
                var user = localStorage.getItem('email')
                this.getUserAnswerData(storeService.serviceId,user)
                var status = storeService.status
                if(status==2||status==3){
                    this.showResult=true
                    this.passPercent = (((storeService.servicePassScore||0)/this.totalNum).toFixed(2)*100)+'%'
                }
            },
            cancel(){
                this.exitVisible=true
            },
            goBack(){
                this.$router.push({path:'/service'})
            },
            submitPrepare(){
                this.$refs['form'].clearValidate()
                this.$nextTick(() => {
                    this.$refs['form'].validate((valid,object) => {
                        if (valid) {
                            // console.log('submit',this.form)
                            this.confirmVisible=true
                        }else {
                            var obj = Object.keys(object)[0]
                            let dom = this.$refs[obj]
                            dom.$el.scrollIntoView({
                                //滚动到指定节点
                                block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
                                behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
                            })
                            // console.log('error submit!!');
                            return false;
                        }
                    })
                })
            },
            submit(){
                this.confirmVisible = false
                var score=0
                var list=[]
                var len = Object.keys(this.form).length
                for(var i=0;i<len;i++){
                    list.push(this.form['sub'+i])
                }
                score = this.calScore()
                var storeService = this.$store.state.serviceInfo
                //var positionInfo = this.$store.state.positionInfo
                var params={}
                params.serviceId =storeService.serviceId
                params.versionId = storeService.serviceVersion
                params.score = score
                params.possible = 20
                params.positionId = 0
                params.status = score > storeService.servicePassScore ? 1: 0
                params.detail = JSON.stringify(list)
                params.applicantEmail=localStorage.getItem('email')
                // console.error('传值是',params)
                // return
                this.loading=true
                this.$axios.post(this.$URL.serviceTestUrl,params).then(res=>{
                    this.loading=false
                    if(res.code==0){
                        this.completionDialogVisible = true
                    }else{
                        this.$message.error({message:res.msg})
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error({message:err})
                })
            },
            handleCompletionConfirm() {
                this.completionDialogVisible = false
                this.goBack()
            },
            calScore(){//算正确分数 总分40
                var score=0
                this.correctNum=0
                if(this.form.sub0==1) {score += 1;this.correctNum++}
                if(this.form.sub1==0) {score += 1;this.correctNum++}
                if(this.form.sub2==1) {score += 1;this.correctNum++}
                if(this.form.sub3==3) {score += 1;this.correctNum++}
                if(this.form.sub4==1) {score += 1;this.correctNum++}
                if(this.form.sub5==2) {score += 1;this.correctNum++}
                if(this.form.sub6==4) {score += 1;this.correctNum++}
                if(this.form.sub7==2) {score += 1;this.correctNum++}
                if(this.form.sub8==1) {score += 1;this.correctNum++}
                if(this.form.sub9==2) {score += 1;this.correctNum++}
                if(this.form.sub10==3) {score += 1;this.correctNum++}
                if(this.form.sub11==2) {score += 1;this.correctNum++}
                if(this.form.sub12==1) {score += 1;this.correctNum++}
                if(this.form.sub13==3) {score += 1;this.correctNum++}
                if(this.form.sub14==3) {score += 1;this.correctNum++}
                if(this.form.sub15==3) {score += 1;this.correctNum++}
                if(this.form.sub16==2) {score += 1;this.correctNum++}
                if(this.form.sub17==4) {score += 1;this.correctNum++}
                if(this.form.sub18==3) {score += 1;this.correctNum++}
                if(this.form.sub19==2) {score += 1;this.correctNum++}
                return score
            },
        },
        watch:{
            $route(to,from){
                // console.log(from.path)
                if(to.path==='/dentalAccountingV2Test'){
                    this.getData()
                }
            }
        }
    }
</script>
<style scoped>
    .score{
        top:15px
    }
    .el-radio-group{
        width: 100%;
    }
    .el-radio{
        width: 100%;
        /* display: flex; */
        align-items: center;
        line-height: 20px!important;
        height: auto!important;
        display: flex;
        margin: 10px 0;
    }
    /deep/ .el-radio__label {
        white-space: normal;  /* 换行 */
    }

    /deep/ .el-checkbox__label {
        white-space: normal;  /* 换行 */
    }
    .rightPic{
        width: 20px;
        height:20px;
    }
    .review{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
</style>
